// @flow
import styled from "styled-components";

export const Expander = styled.div`
	padding: 5%;
`;

export default Expander;